









































import {
  ChoiceQuestion,
  Component,
  ComponentConfig,
  ComponentStyle,
  ComponentStyleDefinition,
  InjectComponent,
  Vue,
  VueComponent,
  Prop,
} from "@zoovu/runner-browser-api";

import { ChoiceQuestionView, QuestionConfiguration } from "@zoovu/runner-web-design-base/index";

@Component({
  name: "ChoiceQuestionView",
  mixins: [ChoiceQuestionView],
})
export default class ChoiceQuestionViewExtended extends Vue {
  @ComponentConfig(QuestionConfiguration)
  private componentConfiguration: QuestionConfiguration;

  @ComponentStyle()
  componentStyle: ComponentStyleDefinition;

  @InjectComponent("RadioButtonAnswerView")
  radioButtonAnswerView: VueComponent;

  @InjectComponent("CheckboxAnswerView")
  checkboxAnswerView: VueComponent;

  @InjectComponent("QuestionHeadView")
  questionHeadView: VueComponent;

  @Prop()
  question: ChoiceQuestion;

  maxTextHeights = [];

  mounted(): void {
    this.clearAllHeights();
    this.updateAnswerTextHeight();
    this.updateImageBox();
  }

  updateAnswerTextHeight(): void {
    /* eslint-disable no-param-reassign */
    this.maxTextHeights = (this.$refs.answerElement as Vue[]).reduce(
      (maxTextHeights, { $children: [choiceAnswer] }, index) => {
        if (!(choiceAnswer.$refs.choiceAnswerLabel as HTMLElement)) {
          return maxTextHeights;
        }

        const rectAnswerHeight = (choiceAnswer.$refs.choiceAnswerLabel as HTMLElement).getBoundingClientRect().height;

        const topKey = this.answersPerRow[index];

        if (maxTextHeights[topKey] === undefined) {
          maxTextHeights[topKey] = {
            answerTextHeight: 0,
          };
        }

        if (maxTextHeights[topKey].answerTextHeight < rectAnswerHeight) {
          maxTextHeights[topKey].answerTextHeight = rectAnswerHeight;
        }

        return maxTextHeights;
      },
      []
    );
    /* eslint-enable no-param-reassign */
  }

  updateImageBox(): void {
    /* eslint-disable no-param-reassign */
    this.imageHeights = (this.$refs.answerElement as Vue[]).reduce(
      (imageHeights, { $children: [choiceAnswer] }, index) => {
        if (!choiceAnswer.$refs.imageBoxElement) {
          return imageHeights;
        }

        const topKey = this.answersPerRow[index];

        const answers = this.getAnswersInTheSameRow(index);

        imageHeights[topKey] = this.hasImageInRow(answers[0], answers[1]) ? "100%" : "0px";

        return imageHeights;
      },
      []
    );
    /* eslint-enable no-param-reassign */
  }

  beforeMount(): void {
    window.addEventListener("resize", this.resizeEventListener);
  }

  beforeDestroy(): void {
    window.removeEventListener("resize", this.resizeEventListener);
  }

  resizeEventListener = async (): Promise<void> => {
    this.clearAllHeights();
    await this.$nextTick();
    this.updateAnswerTextHeight();
    this.updateImageBox();
  };
}
